import { VITE_CONNECT_CALLBACK_URL } from "./constants";

export const redirectBackWithError = (error: string) => {
  window.location.href = `${VITE_CONNECT_CALLBACK_URL}?error=${error}`;
};
